import { c as _c } from "react/compiler-runtime";
import React from 'react';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import usePDPPhotos from 'data-hooks/usePDPPhotos/index';
import useRemoveBrokenImageUrls from 'global-state/brokenImageUrls/useRemoveBrokenImageUrls';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import { getMainImageImgixPropsForPhoto } from '../PDPDesktopHeroGallery/helpers/imgix-props';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';
const NO_PHOTOS = [];

// Description tab: the copy PDPProductDescription shows in the rail today, minus
// the details-and-care link, which the layout revamp gives its own tab
const PDPInfoDescriptionSection = () => {
  const $ = _c(16);
  const {
    data: t0
  } = useProductAttributes();
  const {
    description,
    additional_attributes: additionalAttributes
  } = t0;
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    loading: photosLoading,
    data: photosData
  } = usePDPPhotos();
  const lifestylePhotos = useRemoveBrokenImageUrls(photosData?.studioPhotos ?? NO_PHOTOS);
  const showpieceDesc = additionalAttributes?.showpiece_desc;
  let t1;
  if ($[0] !== basicDetails?.hero_images || $[1] !== lifestylePhotos) {
    let t2;
    if ($[3] !== lifestylePhotos) {
      t2 = hero => lifestylePhotos.find(t3 => {
        const {
          id
        } = t3;
        return id === hero?.img?.url;
      });
      $[3] = lifestylePhotos;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = (basicDetails?.hero_images ?? []).map(t2).find(Boolean);
    $[0] = basicDetails?.hero_images;
    $[1] = lifestylePhotos;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const firstLifestylePhoto = t1;
  const photo = photosLoading ? null : firstLifestylePhoto ?? photosData?.configurationPhotos?.[0] ?? lifestylePhotos[0];
  let t2;
  if ($[5] !== photo || $[6] !== photosData) {
    t2 = !!photo && <JBProductImage className="w-full" forPage="pdp" alt={photosData?.productName ? String(photosData.productName) : ""} {...getMainImageImgixPropsForPhoto(photo, photosData?.enableCrops)} sizes="(max-width: 767px) 100vw, 30vw" />;
    $[5] = photo;
    $[6] = photosData;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const aside = t2;
  let t3;
  if ($[8] !== description) {
    t3 = !!description && <p className="text-sm text-gray mt-0 mx-0 mb-4">{description}</p>;
    $[8] = description;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== showpieceDesc) {
    t4 = !!showpieceDesc && <p className="text-sm text-gray m-0">{showpieceDesc}</p>;
    $[10] = showpieceDesc;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== aside || $[13] !== t3 || $[14] !== t4) {
    t5 = <PDPInfoSectionLayout aside={aside}>{t3}{t4}</PDPInfoSectionLayout>;
    $[12] = aside;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default PDPInfoDescriptionSection;